import axios from "axios";
import { centerAllotMedicine, centersApi, getCenterMedicinesApi } from "../../constants/apis/clinic_apis";
import { getUserToken } from "../../utils/localStoarege";

export const getCenters = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.get(centersApi + query || "", config);
    return response;
};

export const getCenterAllotMedicines = async (centerName) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.get(centerAllotMedicine + "?page_size=100&center_name=" + centerName, config);
    return response;
};

export const getCenterMedicinesHistory = async (centerName) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.get(getCenterMedicinesApi + centerName, config);
    return response;
};
